import { render, staticRenderFns } from "./u-btn-text-underline.vue?vue&type=template&id=ef7c771c&scoped=true&"
import script from "./u-btn-text-underline.vue?vue&type=script&lang=js&"
export * from "./u-btn-text-underline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7c771c",
  null
  
)

export default component.exports